import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Select, 
  MenuItem, 
  FormControl, 
  InputLabel,
  Grid
} from '@mui/material';

const cameraMovementOptions = [
  { value: 'pan_right', label: 'Sağa Kaydırma' },
  { value: 'pan_left', label: 'Sola Kaydırma' },
  { value: 'zoom_in', label: 'Yakınlaştırma' },
  { value: 'zoom_out', label: 'Uzaklaştırma' },
  { value: 'rotate', label: 'Döndürme' },
  { value: 'dolly', label: 'İleri-Geri' },
];

const durationOptions = [
  { value: '3', label: '3 saniye' },
  { value: '4', label: '4 saniye' },
  { value: '5', label: '5 saniye' },
  { value: '6', label: '6 saniye' },
];

const qualityOptions = [
  { value: 'draft', label: 'Taslak (Hızlı)' },
  { value: 'standard', label: 'Standart' },
  { value: 'high', label: 'Yüksek Kalite (Yavaş)' },
];

const VideoToolOptions = ({ settings, onChange, onApply }) => {
  const handleCameraMovementChange = (event) => {
    onChange({ ...settings, cameraMovement: event.target.value });
  };

  const handleDurationChange = (event) => {
    onChange({ ...settings, duration: event.target.value });
  };
  
  const handleQualityChange = (event) => {
    onChange({ ...settings, quality: event.target.value });
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
        Video Oluşturma
      </Typography>
      
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel id="camera-movement-label">Kamera Hareketi</InputLabel>
            <Select
              labelId="camera-movement-label"
              value={settings.cameraMovement}
              label="Kamera Hareketi"
              onChange={handleCameraMovementChange}
            >
              {cameraMovementOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel id="duration-label">Süre</InputLabel>
            <Select
              labelId="duration-label"
              value={settings.duration}
              label="Süre"
              onChange={handleDurationChange}
            >
              {durationOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel id="quality-label">Kalite</InputLabel>
            <Select
              labelId="quality-label"
              value={settings.quality}
              label="Kalite"
              onChange={handleQualityChange}
            >
              {qualityOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={onApply}
        >
          Video Oluştur (30 Kredi)
        </Button>
      </Box>
    </Box>
  );
};

export default VideoToolOptions;
